export class ProfileCardHarnessController {
  public statusOptions = ["Available", "Away", "Busy", "Offline"];
  public statusGlyphs = ["available-glyph", "away-glyph", "busy-glyph"];
  public statusGlyph: string;
  public statusLabel: string;

  public statusChanged(param: any) {
    this.statusGlyph = this.statusGlyphs[this.statusOptions.indexOf(param)];
    this.statusLabel = param;
  }
}
